<template>
  <el-form
    ref="formRef"
    :model="props.model"
    :rules="props.rules"
    :disabled="props.disabled"
    hide-required-asterisk
    label-position="top"
    label-width="100%"
    :validate-on-rule-change="false"
    @submit.prevent="onSubmit"
    @keypress.enter="keyPressEnter"
  >
    <slot />
  </el-form>
</template>

<script setup>
const props = defineProps({
  model: {
    type: Object,
    default: undefined,
  },
  rules: {
    type: Object,
    default: undefined,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  submitOnEnter: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['submit']);

// Refs
const formRef = ref(null);

// Methods
const keyPressEnter = (event) => {
  if (props.submitOnEnter) {
    event.preventDefault();
    onSubmit();
  }
};

const onSubmit = async(event) => {
  if (!props.rules) {
    emit('submit', event);
    return;
  }

  const isValid = await formRef.value.validate().catch(() => false);

  if (isValid) {
    emit('submit', event);
  } else {
    console.warn('Form is not valid!');
  }
};

defineExpose({
  onSubmit,
});
</script>
